export default __webpack_public_path__ + "static/wendy-glasses-707e3b3b7182767727cfbac4854785f3.jpg";